import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt ein Template zurück.
 */
export function getTemplate(id: number): JQueryPromise<modelsGet.ITemplate>
{
    var endpoint = new URI("api/templates");
    endpoint.segment(id.toString());

    return api.get<modelsGet.ITemplate>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Templates zurück.
 */
export function getTemplates(): JQueryPromise<modelsGet.ITemplate[]>
{
    var endpoint = new URI("api/templates");

    return api.get<modelsGet.ITemplate[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(jsonData: modelsPost.ITemplate): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/templates/create",
        data: JSON.stringify(jsonData)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, jsonData: modelsPost.ITemplate): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/templates/edit/${id}`,
        data: JSON.stringify(jsonData)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/templates/delete/${id}`
    });
}